<template>
    <div style="height: 250px">
        <canvas id="ticketsHistory"></canvas>
    </div>
</template>

<script>
    import Chart from "chart.js";
    import Axios from "../utils/http/Axios";
    import moment from 'moment';
    moment.locale('es');
    export default {
        name: "ticketsHistory",
        props: {
            unresolvedTickets: {
                type: Array,
                required: true,
            },
            ticketsInLevel3: {
                type: Array,
                required: false,
                default: []
            }

        },
        data() {
            return {
                chart: undefined,

            }
        },
        mounted() {
            this.drawChart(this.unresolvedTickets);

        },
        watch: {
            unresolvedTickets: function (newVal) {
                this.drawChart(newVal);
            },
            ticketsInLevel3: function (newVal) {
                this.drawChart(this.unresolvedTickets);
            },
        },
        methods: {
            drawChart: function (data) {
                if (this.chart !== undefined) {
                    this.chart.destroy();
                }
                moment.locale('es');

                if (data === undefined) {
                    return
                }
                let max = Math.max(...data.map(t => t.y), ...this.ticketsInLevel3.map(t => t.y));
                let canvas = document.getElementById("ticketsHistory")
                Chart.defaults.derivedLine = Chart.defaults.line;
                let that = this;
                let custom = Chart.controllers.line.extend({
                    draw: function (a) {
                        Chart.controllers.line.prototype.draw.call(this, a);
                        that.drawLabels(this, canvas.getContext("2d"));
                    }
                });

                Chart.controllers.derivedLine = custom;

                let chartOptions = {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        display: true
                    },
                    scales: {
                        yAxes: [{
                            gridLines: {
                                display: false
                            },
                            ticks: {
                                min: 0,
                                stepSize: Math.round(max / 2),
                                max: max
                            }
                        }],
                        xAxes: [{
                            type: 'time',
                            time: {
                                unit: 'day',
                                tooltipFormat:'MMM DD', // <- HERE
                            },
                            gridLines: {
                                display: false
                            },
                            ticks: {
                                max: data.length === 0 ? 0 : data[data.length - 1].x + 1 * 24 * 60 * 60 * 1000
                            }

                        }]
                    }
                };

                this.chart = new Chart(canvas, {
                    data: {
                        datasets: [{
                            fill: false,
                            backgroundColor: '#006AD866',
                            borderColor: '#006AD866',
                            data: data,
                            label: "Tickets pendientes",
                            type: "derivedLine",

                        }, {
                            type: 'bar',
                            data: this.ticketsInLevel3,
                            label: "Tickets subidos"

                        }],
                    },
                    options: chartOptions
                });
            },
            drawLabels(t, ctx) {
                let chartInstance = t.chart;
                let datasets = chartInstance.config.data.datasets;
                let index = datasets[0].data.length - 1;
                ctx.save();
                ctx.font = Chart.helpers.fontString(20, Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
                ctx.fillStyle = '#22619F';
                ctx.backgroundColor = "white"
                ctx.textBaseline = 'bottom';

                let meta = chartInstance.controller.getDatasetMeta(0);
                let len = meta.data.length - 1;
                if (len < 0) {
                    return
                }
                let xOffset = meta.data[len]._model.x + 5;
                let yOffset = meta.data[len]._model.y + 10;
                ctx.fillText(datasets[0].data[index].y.toString(), xOffset, yOffset);

                ctx.restore();
            },
        }
    }
</script>

<style scoped>

</style>
